export function checkBetaHc(hcId) {
    const betaHcs = [19306883,17839118,18848807];
    return !process.env.VUE_APP_REDIRECT_NON_BETA && !betaHcs.includes(hcId)
   
}